import React, { useState } from "react"
import { TicketDetail, ShowMore } from "../../styles/ticketList.style"
import ArrowOrange from "../../images/arrow_orange.svg"
import { ArrowDown } from "../../styles/ticketAccordion.style"

export default function TicketListDetail({ content = "" }) {
  const [showMore, setShowMore] = useState(false)
  const toggleShowMore = () => setShowMore(showMore => !showMore)
  return (
    content && (
      <TicketDetail className="Col">
        {!showMore && content ? `${content.substring(0, 100)}...` : content}
        <ShowMore onClick={toggleShowMore}>
          <label style={{ marginRight: 11 }}>
            {showMore ? "Show Less" : "Show More"}
          </label>{" "}
          {content?.length > 100 ? (
            <ArrowDown
              src={ArrowOrange}
              open={showMore}
              height="5"
              width="5"
              marginTop={5}
            />
          ) : null}
        </ShowMore>
      </TicketDetail>
    )
  )
}
